import { FC, memo } from 'react';
import styles from './index.less';

interface StickySubmitButtonProps {
  /**取消按钮文字*/
  defaultText?: string;
  /**提交按钮文字*/
  submitBtnText?: string;
  /**取消按钮点击函数*/
  defaultBtnClick?: () => void;
  /**提交按钮点击函数*/
  submitBtnClick?: () => void;
}

const StickySubmitButton: FC<StickySubmitButtonProps> = ({
  defaultText = '取消',
  submitBtnText = '提交',
  defaultBtnClick,
  submitBtnClick,
}) => {
  return (
    <div className={styles.container}>
      <div onClick={defaultBtnClick} className={styles['default-btn']}>
        {defaultText}
      </div>
      <div onClick={submitBtnClick} className={styles['submit-btn']}>
        {submitBtnText}
      </div>
    </div>
  );
};
export default memo(StickySubmitButton);
